import { BaseOrder } from '../..';

export function getShippingRateFileName(order: BaseOrder): string {
  const method = order.shippingMethod?.toUpperCase();

  return method === 'STANDARD' || !method ? '' : `${method}_`;
}
